import React, { useState } from "react";
import { AuthenticatedTemplate, useMsal } from "@azure/msal-react";
import {
  ChevronDown as DownIcon,
  ChevronUp as UpIcon,
  LogOut as LogoutIcon,
} from "react-feather";
import { CSSTransition } from "react-transition-group";

import Avatar from "../../common/components/Avatar";

const UserProfile: React.FC = () => {

  const [isShow, setShow] = useState(false);
  const { instance } = useMsal();
  const [account] = useState(() => instance.getActiveAccount());
  const [userId] = useState(account?.homeAccountId ?? "");
  const [displayName] = useState(account?.name ?? "");
  const [jobTitle] = useState((account?.idTokenClaims as any)?.jobTitle ?? "");

  return (
    <div className="flex-grow-1 d-flex align-items-center justify-content-end py-1 pl-sm-3">
      <AuthenticatedTemplate>
        <a
          href="#0"
          className="d-sm-none mx-3 stretched-link"
          onClick={(e) => {
            e.preventDefault();
            setShow(!isShow);
          }}
        >
          <Avatar
            id={userId}
            name={displayName}
            size="sm"
          />
        </a>

        <div className="d-none d-sm-block">
          <Avatar
            id={userId}
            name={displayName}
            size="sm"
          />
        </div>

        <div className="d-none d-sm-flex flex-column justify-content-center flex-grow-1 ml-2">
          <div className="font-weight-bold">
            {displayName}
          </div>
          {!!jobTitle && (
            <div>
              {jobTitle}
            </div>)}
        </div>

        <a
          href="#0"
          className="d-none d-sm-block stretched-link text-neutral p-2"
          onClick={(e) => {
            e.preventDefault();
            setShow(!isShow);
          }}
        >
          {isShow ? <UpIcon /> : <DownIcon />}
        </a>

        <CSSTransition
          classNames="fade-top"
          in={isShow}
          timeout={{
            appear: 200,
            enter: 200,
            exit: 100,
          }}
          unmountOnExit
        >
          <div
            className="position-absolute bg-panel-dark box-shadow border-left border-bottom text-nowrap"
            style={{
              top: "100%",
              right: 0,
              minWidth: "100%",
              marginTop: "1px",
              zIndex: 1,
            }}
          >
            <div className="d-sm-none px-3 py-2">
              <div className="font-weight-bold">{displayName}</div>
              {!!jobTitle && (<div>{jobTitle}</div>)}
            </div>
            <div className="d-flex align-items-center position-relative px-3 py-2">
              <LogoutIcon />
              <a
                href="#0"
                className="stretched-link pl-2"
                onClick={async (e) => {
                  e.preventDefault();
                  await instance.logout();
                }}
              >
                Sign out
              </a>
            </div>
          </div>
        </CSSTransition>

      </AuthenticatedTemplate>
    </div>
  );
}

export default UserProfile;
